import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import $ from 'jquery';
import Ajax from '../ajax/Ajax';

class Reports extends Component {
	
	constructor(props) {
		super(props);
		this.state = {reports: false, keys: false, showEditor: false, reportTitleInput: "", reportAuthorInput: "", reportContentInput: ""};
        this.openEditor = this.openEditor.bind(this);
        this.closeEditor = this.closeEditor.bind(this);
        this.saveReport = this.saveReport.bind(this);
	}
	
	componentWillMount() {
		var obj = this;
		Ajax.getReports().then(function(reports) {			
			obj.setState({reports: reports, keys: Object.keys(reports).reverse()});			
		});
	}
	
	openEditor() {
		this.setState({showEditor: true});
    }

    closeEditor() {
        this.setState({showEditor: false});
    }    

    saveReport() {
        var obj = this;
        var id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
        var report = {title: this.state.reportTitleInput, author: this.state.reportAuthorInput, content: this.state.reportContentInput}
        Ajax.getReports().then((reports) => {            
            reports[id] = report;
            
            Ajax.postReports(reports).then((output) => {
                obj.setState({reports: reports, keys: Object.keys(reports)}, obj.closeEditor);
            });            
        });
    }
	
	render() {
        var reports = this.state.reports;
        var keys = this.state.keys;
        var showEditor = this.state.showEditor;
		var obj = this;
		
		return (
		<div className="Reports">			
			
			<div className="ReportList">				
				<div className="AddReportSymbol" onClick={this.openEditor}>Ajouter un rapport...</div>
				
				{reports && keys ? 				
				keys.map(function(key, idx) {					
					var report = reports[key];
					return (
					<div id={key} key={idx} className="Report">
                        <div className="ReportTitle">{report.title}</div>
                        <div className="ReportAuthor">{report.author}</div>
						<div className="ReportContent" dangerouslySetInnerHTML={{__html: report.content.replace(/\n/g, "<br/>")}}></div>
					</div>
					)
				}): null
				}
				
			</div>
            { showEditor ? (
                <div className="Overlay">
                    <div className="OverlayCloseButton" onClick={this.closeEditor}>x</div>
                    <div className="ReportEditor">
                        <div className="ReportEditorLabel">Titre</div>
                        <div className="ReportTitleInput"><input type="text" value={this.state.reportTitleInput} onChange={(event) => { this.setState({reportTitleInput: event.target.value}); } }></input></div>
                        <div className="ReportEditorLabel">Auteur</div>
                        <div className="ReportAuthorInput"><input type="text" value={this.state.reportAuthorInput} onChange={(event) => { this.setState({reportAuthorInput: event.target.value}); } }></input></div>
                        <div className="ReportEditorLabel">Rapport</div>
                        <div className="ReportContentInput"><textarea value={this.state.reportContentInput} resize="false" onChange={(event) => { console.log(event.target.value); this.setState({reportContentInput: event.target.value}); } }></textarea></div>
                        <div className="ReportContentButton" onClick={this.saveReport}>Sauvegarder</div>
                    </div>
                </div>) : null }  
		</div>
		);
	}
}

export default Reports;



// WEBPACK FOOTER //
// ./src/components/Reports.js